import React, {Component} from 'react';
import Nprogress from 'nprogress';
import ReactPlaceholder from 'react-placeholder';
import 'nprogress/nprogress.css';
import 'react-placeholder/lib/reactPlaceholder.css';

export default function asyncComponent(importComponent) {
    class AsyncFunc extends Component {
        constructor(props) {
            super(props);
            this.state = {
                component: null
            };
        }

        UNSAFE_componentWillMount() {
            Nprogress.start();
        }

        componentWillUnmount() {
            this.mounted = false;
        }

        async componentDidMount() {
            this.mounted = true;
            let ComponentClass;
            try {
                const {default: Component} = await importComponent();
                ComponentClass = Component;
            } catch (ex) {
                if (ex && ex.name === 'ChunkLoadError') {
                    window.location.reload();
                } else {
                    console.error(ex);
                }
                return;
            }
            Nprogress.done();
            if (this.mounted) {
                this.setState({
                    component: <ComponentClass {...this.props} />
                });
            }
        }

        render() {
            const Component = this.state.component || <div/>;
            return (
                <ReactPlaceholder type="text" rows={7} ready={Component !== null}>
                    {Component}
                </ReactPlaceholder>
            );
        }
    }

    return AsyncFunc;
}
